import { useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { useParams } from 'react-router';
import { MdContentCopy, MdCheck, MdOpenInNew } from 'react-icons/md';
import { AppButton, useOpenApp } from '~components/AppCta';
import { Mark } from '~components/Logo';
import { shared } from '~styles';
import { styles } from './styles';

// Invite landing for links shared from the app's referrals screen. The code is
// taken from the URL as-is; sign-up validates it for real.
export function Referral() {
  const {
    code = ''
  } = useParams();
  const [copied, setCopied] = useState(false);
  useOpenApp(`signup?referralCode=${code}`);
  return <main {...stylex.props(styles.container)}>
      <Mark size={56} />
      <h1 {...stylex.props(styles.title)}>You&apos;re invited to Tribys</h1>
      <p {...stylex.props(shared.muted, styles.lead)}>
        Small groups, real places, real life. Use this code when you sign up
        and you&apos;ll both earn 1 month of Pro Subscription for free.
      </p>
      <button type="button" {...stylex.props(styles.code)} onClick={() => copy(code, setCopied)}>
        {code}
        {copied ? <MdCheck size={20} {...stylex.props(styles.codeIcon)} /> : <MdContentCopy size={20} {...stylex.props(styles.codeIcon)} />}
      </button>
      <p {...stylex.props(shared.muted, styles.hint)}>
        {copied ? 'Copied!' : 'Tap the code to copy it'}
      </p>
      <AppButton path={`signup?referralCode=${code}`} label="Get the Tribys app" icon={<MdOpenInNew size={20} />} />
    </main>;
}
const copy = async (code: string, setCopied: (copied: boolean) => void) => {
  await navigator.clipboard.writeText(code);
  setCopied(true);
  setTimeout(() => setCopied(false), 2000);
};